import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Heading, Text, ArrowRightIcon } from '@elseu/sdu-titan';
import styled from 'styled-components';
import { Icon } from '../Icon/Icon.js';
import { Link } from '../Link/Link.js';

/**
 * The styled component for the Feature
 */
var StyledFeature = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
/**
 * The wrapper for the feature icon
 */
var IconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  border-radius: ", ";\n  background-color: ", ";\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  border-radius: ", ";\n  background-color: ", ";\n  margin-bottom: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.borderRadius[2];
}, function (_a) {
  var theme = _a.theme,
    background = _a.background;
  return background === 'white' ? theme.designTokens.colors.secondary10 : theme.designTokens.colors.secondary30;
}, function (_a) {
  var theme = _a.theme;
  return theme.spacing[6];
});
/**
 * The Feature component
 *
 * @param {FeatureProps} props - The props for the Feature component.
 * @returns {JSX.Element} The Feature component.
 */
var Feature = function (_a) {
  var button = _a.button,
    description = _a.description,
    icon = _a.icon,
    title = _a.title,
    _b = _a.background,
    background = _b === void 0 ? 'white' : _b;
  return jsxs(StyledFeature, {
    children: [icon && jsx(IconWrapper, {
      background: background,
      children: jsx(Icon, {
        icon: icon,
        size: 32
      })
    }), title && jsx(Heading, {
      renderAs: "p",
      heading: "h5",
      children: title
    }), description && jsx(Text, {
      as: "p",
      type: "label",
      children: description
    }), button && jsx(Link, {
      to: button.href,
      suffixAdornment: jsx(ArrowRightIcon, {}),
      isExternal: button.external,
      children: button.label
    })]
  });
};
var templateObject_1, templateObject_2;

export { Feature, StyledFeature };
//# sourceMappingURL=Feature.js.map
